import { render } from "./index.vue?vue&type=template&id=417be2be&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=417be2be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417be2be"],['__file',"src/common/components/FileLoaderBox/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "417be2be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('417be2be', __exports__)) {
    api.reload('417be2be', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=417be2be&scoped=true", () => {
    api.rerender('417be2be', render)
  })

}


export default __exports__